import type { ReactNode } from "react";

import { LorumLogoMark } from "@shared/design-system-kit";

import styles from "./full-screen-loader.module.css";

export function FullScreenLoader(): ReactNode {
	return (
		<div className={styles.fullScreenLoader} data-testid="full-screen-loader">
			<LorumLogoMark className={styles.logo} />
		</div>
	);
}
